module.exports = __webpack_public_path__ + "static/media/summer.8e261e60.jpg";